export const ORGANIZATIONS_API_URLS = {
    LIST: "/organizations",
    INFO: "/organization/info",
    CREATE: "/organization/create",
    UPDATE: "/organization/update",
    REMOVE: "/organization/remove",
    USER_ADD: "/organization/user/add",
    USER_REMOVE: "/organization/user/remove",
    USER_ROLE: "/organization/user/role",
    LOCATION_ADD: "/organization/location/add",
    LOCATION_ADD_ALL: "/organization/location/add_all",
    LOCATION_REMOVE: "/organization/location/remove",
    AVAILABLE_LOCATIONS: "/organization/available_locations",
};
